import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
      fill: "#B9A087"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22.1039 11.5733C21.5719 10.4324 17.4754 11.3427 13.0833 13.3939C8.69114 15.4452 5.35716 17.9929 5.88917 19.1338C6.42119 20.2747 10.5828 19.5062 14.9808 17.4609C19.3729 15.4097 22.6419 12.7141 22.1098 11.5733H22.1039Z",
      fill: "#F2EDE8"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22.1039 11.5733C21.5719 10.4324 17.4754 11.3427 13.0833 13.3939C8.69114 15.4452 5.35716 17.9929 5.88917 19.1338C6.42119 20.2747 10.5828 19.5062 14.9808 17.4609C19.3729 15.4097 22.6419 12.7141 22.1098 11.5733H22.1039Z",
      stroke: "#F2EDE8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.6044 9.36805C12.1374 10.0538 11.3276 10.4321 10.5059 10.3552C6.92957 10.0301 7.52661 14.3158 8.34829 16.0774C9.26454 18.0459 11.7887 17.4547 14.5079 16.1838C17.2271 14.9129 19.302 13.3641 18.3857 11.3956C17.564 9.63406 14.6143 6.41238 12.5985 9.36213L12.6044 9.36805Z",
      fill: "#F2EDE8",
      stroke: "#B9A087",
      "stroke-width": "0.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }